/* unplugin-vue-components disabled */import script from "./WxMinGamePayBaseConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./WxMinGamePayBaseConfig.vue?vue&type=script&setup=true&lang=ts"

import "./WxMinGamePayBaseConfig.vue?vue&type=style&index=0&id=14fbae34&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14fbae34"]])

export default __exports__